import axios from 'axios'

// token拦截器
// Add a request interceptor
axios.interceptors.request.use(function (config) {
    // Do something before request is sent
    const token = localStorage.getItem("token");
    // 只有拿到真实 token 才带 Authorization，避免发出 "Bearer undefined" 这种脏头
    if (token && token !== 'undefined' && token !== 'null') {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});


// Add a response interceptor
axios.interceptors.response.use(function (response) {
    const { authorization } = response.headers;
    authorization && localStorage.setItem("token", authorization);
    return response;
}, function (error) {
    if (error.response && error.response.status) {
        const { status } = error.response;
        console.log('-------------------------------***',status)
        if (status === 401) {
            // 清掉失效的登录态，避免拿着旧 token 反复请求
            localStorage.removeItem("token");
            localStorage.removeItem("userInfo");
            // hash 路由下管理端路径统一以 #/admin 开头，只有管理端才跳登录页；
            // 前台用户页（/works、/points 等）遇到 401 不应被弹去管理端登录页
            if (window.location.hash.startsWith("#/admin")) {
                window.location.href = "#/admin/login";
            }
            return Promise.reject(error);
        }
    }
    return Promise.reject(error);
});